"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatAction = void 0;
var UserStatAction;
(function (UserStatAction) {
    UserStatAction["NEW"] = "new";
    UserStatAction["EDIT"] = "edit";
})(UserStatAction || (exports.UserStatAction = UserStatAction = {}));
//# sourceMappingURL=userStats.js.map